import { IResponseBaseTDto } from "@sprytki-frontend-apps/common";
import { AutocompleteDto } from "api/interfaces/api";
import { apiClient } from "./apiClient";
const CHAINS = 'chains'

export const ChainServiceAPI = {
	getLocations: async (id: string): Promise<IResponseBaseTDto<AutocompleteDto[]>> => {
		const response = await apiClient.get(`${CHAINS}/${id}/locations`);
		return response.data;
	},
}
